import { Box } from "@mui/material";
import LanguageContext from "components/LanguageContext";
import SelectTagsContent from "components/templates/news/SelectTagsContent";
import DSFRModal from "components/templatesComponents/DSFRModal";
import Icon from "components/templatesComponents/Icon";
import PropTypes from "prop-types";
import React, { useContext, useRef } from "react";
import { getTranslateIndex } from "utils/commonUtils";
import t from "utils/locales/translation.json";

const ModalTagsBlock = (props) => {
  const { label, allTags = [], selectedTags = [], handleSelectTagsForm = null } = props;

  const { language } = useContext(LanguageContext);
  const modalRef = useRef(null);

  const openModal = () => {
    modalRef.current.openModal();
  };
  const closeModal = () => {
    modalRef.current.closeModal();
  };

  if (allTags?.length === 0) {
    return null;
  }

  return (
    <div className="fr-input-group" id={`input-group-${label}`}>
      <label className="fr-label fr-text--bold" htmlFor={`input-${label}`}>
        {label}
      </label>
      <div aria-label={t[language].all_news.tag_list} />
      <Box sx={{ position: "relative", "& > input, span": { cursor: "pointer" } }}>
        <input
          className="fr-input fr-text--sm"
          value={
            selectedTags.length === 0
              ? t[language].all_news.empty_placeholder
              : `${selectedTags.length} ${
                  t[language].all_news.filled_placeholder[getTranslateIndex(selectedTags.length)]
                }`
          }
          aria-describedby={`input-${label}`}
          id={`input-${label}`}
          type="text"
          onClick={openModal}
        />
        <Icon
          iconDSFR="arrow-down-s-line"
          size="sm"
          sx={{ position: "absolute", top: 8, right: 16 }}
          onClick={openModal}
        />
      </Box>
      <DSFRModal
        ref={modalRef}
        aria-labelledby={`modal-${label}`}
        aria-describedby={`select-tags-${label}`}
        onClose={closeModal}
        top
      >
        <div className="fr-m-1w">
          <h4 className="fr-ml-1w">{label}</h4>
          <SelectTagsContent
            allTags={allTags}
            selectedTags={selectedTags}
            handleSelectTagsForm={handleSelectTagsForm}
            scrollable
          />
          <Box
            component="button"
            type="button"
            className="fr-btn fr-mt-1w fr-my-2w"
            sx={{ justifyContent: "center", width: "calc(100% - 16px)" }}
            onClick={closeModal}
          >
            {t[language].all_news.confirm_button}
          </Box>
        </div>
      </DSFRModal>
    </div>
  );
};

ModalTagsBlock.propTypes = {
  label: PropTypes.string.isRequired,
  allTags: PropTypes.arrayOf(PropTypes.string),
  selectedTags: PropTypes.arrayOf(PropTypes.string),
  handleSelectTagsForm: PropTypes.func,
};
export default ModalTagsBlock;
